module.exports = __webpack_public_path__ + "img/ico-close.1382b81f.svg";